import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    
    if (!token) {
      navigate('/admin');
      return;
    }

    const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

    fetch(`${API}/admin/verify`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(res => {
      if (res.ok) {
        setIsValid(true);
      } else {
        localStorage.removeItem('admin_token');
        navigate('/admin');
      }
    })
    .catch(() => {
      localStorage.removeItem('admin_token');
      navigate('/admin');
    });
  }, [navigate]);

  if (isValid === null) {
    return (
      <div className="min-h-screen bg-white dark:bg-[#0D1117] flex items-center justify-center">
        <div className="text-gray-600 dark:text-gray-400">Verifying access...</div>
      </div>
    );
  }

  return isValid ? children : null;
};

export default ProtectedRoute;